import React from 'react';
import { Box, Typography } from '@mui/material';

export const SettingsPage: React.FC = () => {
    return (
        <Box>
            <Typography variant="h4" component="h1" gutterBottom>
                Configuración
            </Typography>
            <Typography variant="body1">
                Configuración del sistema - En desarrollo
            </Typography>
        </Box>
    );
}; 